﻿{
  "community": {
    "name": "Yhteisö",
    "shortDescription": "Yksittäinen tili maksuttomilla aktiviteeteilla",
    "features": [
      "Find and share activities",
      "Unlimited activity cloud storage",
      "Access to Premium Activities"
    ],
    "price": "Vapaa",
    "termName": "Elinaika"
  },
  "personal": {
    "name": "Henk.koht.",
    "shortDescription": "Yksittäinen tili mukautetuilla aktiviteeteilla",
    "features": [
      "Create and edit activities online",
      "Includes personal playlist",
      "Access activities on the go"
    ]
  },
  "professional": {
    "name": "Ammatillinen",
    "shortDescription": "Yksittäinen tili useiden opiskelijoiden kanssa",
    "features": [
      "Manage student assignments",
      "Monitor student progress",
      "Collaborate with team members"
    ]
  },
  "organization": {
    "name": "Organisaatio",
    "shortDescription": "Useita tilejä useilla opiskelijoilla",
    "features": [
      "Instructor management",
      "Organization level reporting",
      "Enterprise privacy settings"
    ],
    "price": "Ota yhteyttä",
    "termName": "1-5 vuoden aikajaksot"
  },
  "trialLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Työpöytäeditorin esikatselunäkymä",
    "note": "Kokeile <1>$t(common:action.free)</1> 30 päivän ajan!",
    "price": "Vapaa",
    "termName": "30 päivän kokeiluversio",
    "footerNote": "1. asenna"
  },
  "boardmakerLicense": {
    "name": "Boardmaker 7",
    "shortDescription": "Täysi työpöytäeditori",
    "note": "",
    "termName": "Kertaluontoinen hankinta",
    "footerNote": "2 asennusta käyttäjää kohti"
  },
  "licenseRequest": {
    "name": "Boardmaker 7",
    "shortDescription": "Useita lisenssejä organisaatioita varten",
    "note": "",
    "price": "Ota yhteyttä",
    "termName": "Määräalennukset",
    "footerNote": "2 asennusta käyttäjää kohti"
  }
}
